import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/apiClient";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import GraceMarksCardDialog from "./GraceMarksCard";
import Loader from "../../Shared/Loader/Loader";
import { useCatchResponse } from '../../../utils/useCatchResponse';

const GraceMarksEntry = (props) => {
    const { catchResponse } = useCatchResponse();
    const [students, setStudents] = useState([]);
    const navigate = useNavigate();
    const [currentStudentIndex, setCurrentStudentIndex] = useState(0);

    useEffect(() => {
        GetGradeMarksList();
    }, []);

    const GetGradeMarksList = async () => {
        try {
            Loader.show();
            let data = {
                ClassId: props?.location?.state?.classId,
                TermId: props?.location?.state?.termId,
                FinancialId: props?.location?.state?.financialId
            };
            const response = await api.post(APIConstant.path.GetGraceMarksEntryList, data);
            if (response.success) {
                setStudents(response.data);
            }
            Loader.hide();
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const handleNext = () => {
        if (currentStudentIndex < students.length - 1) {
            setCurrentStudentIndex(currentStudentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentStudentIndex > 0) {
            setCurrentStudentIndex(currentStudentIndex - 1);
        }
    };

    const handleMarkUpdate = (studentId, index, subject, markValue) => {
        var formatedData = students.map((student) =>
            student.StudentId === studentId
                ? {
                    ...student,
                    SubjectList: student?.SubjectList.map((grade, gradeIndex) =>
                        gradeIndex === index && grade?.SubjectId === subject
                            ? {
                                ...grade,
                                GraceMarks: markValue
                            }
                            : grade
                    ),
                }
                : student
        );
        setStudents(formatedData);
    };

    const AddGradeEntryData = async (isGraft) => {
        try {
            const updatedStudents = students?.map((student) => (
                { ...student, IsGraft: isGraft, FinancialId: props?.location?.state?.financialId })
            );
            await api.post(APIConstant.path.AddUpdateGradingEntry, updatedStudents).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: res.message });
                    navigate('/grace-mark')
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    return (
        <div className="wayment-owner-dashboard et-master-page">
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-arrow-left" onClick={() => navigate('/grace-mark')} style={{ cursor: 'pointer' }}></i>
                    <h2>{props?.location?.state?.className}</h2>
                </div>
            </div>
            <div style={{ flex: 1, overflowY: 'hidden', paddingBottom: '1rem' }}>
                {students.length > 0 && (
                    <GraceMarksCardDialog student={students[currentStudentIndex]} onMarkeChange={handleMarkUpdate} />
                )}
            </div>
            <div className="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-2" style={{ borderTop: '1px solid #dee2e6', marginTop: 'auto', backgroundColor: '#fff' }}>
                <div className="p-d-flex" style={{ gap: '0.5rem' }}>
                    <Button
                        label="Previous"
                        className="p-button-secondary p-button-outlined"
                        onClick={handlePrevious}
                        disabled={currentStudentIndex === 0}
                        style={{ height: '36px' }}
                    />
                    <Button
                        label="Next"
                        className="p-button-secondary p-button-outlined"
                        onClick={handleNext}
                        disabled={currentStudentIndex === students.length - 1}
                        style={{ height: '36px' }}
                    />
                </div>
                <div className="p-d-flex p-jc-end p-ai-center" style={{ gap: '1rem' }}>
                    <Button label="Cancel" onClick={(e) => navigate('/grace-mark')} className="p-button-outlined p-button-secondary" style={{ height: '36px' }} />
                    <Button label="Save as Draft" className="p-button-secondary" onClick={(e) => AddGradeEntryData(true)} style={{ height: '36px' }} />
                    <Button label="Submit All" className="p-button-primary" onClick={(e) => AddGradeEntryData(false)} style={{ height: '36px' }} />
                </div>
            </div>
        </div>
    );
};

export default GraceMarksEntry;
